import React, { useEffect, useState, useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import client from "../lib/api";
import { useSeo } from "../lib/useSeo";
import Layout, { Spinner } from "../components/Layout";
import { NewsCard } from "../components/NewsCard";
import { CAT_LABEL } from "../lib/categories";

export default function Category() {
  const { slug } = useParams();
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const cat = CAT_LABEL[slug] || { name: slug, name_hi: "" };

  useSeo({ title: cat.name, description: `Latest ${cat.name} news on Rapid24News — Fast, Trusted, Fearless.` });

  const load = useCallback((p) => {
    client.get(`/articles`, { params: { category: slug, page: p, limit: 16 } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); });
  }, [slug]);

  useEffect(() => { setItems(null); setPage(1); window.scrollTo(0, 0); load(1); }, [slug, load]);

  const loadMore = () => { const np = page + 1; setPage(np); client.get(`/articles`, { params: { category: slug, page: np, limit: 16 } }).then((r) => setItems((x) => [...x, ...r.data.items])); };

  return (
    <Layout>
      <div className="bg-r24-black text-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="font-head font-bold text-4xl md:text-5xl uc" data-testid="category-title">
            <span className="text-r24-red">{cat.name}</span>
          </h1>
          {cat.name_hi && <p className="font-hindi text-gray-400 text-lg mt-1">{cat.name_hi}</p>}
        </div>
      </div>
      <section className="max-w-7xl mx-auto px-4 py-10">
        {!items ? <Spinner /> : items.length === 0 ? (
          <p className="text-gray-500 py-16 text-center">No stories in this section yet.</p>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-testid="category-grid">
              {items.map((a) => <NewsCard key={a.slug} a={a} />)}
            </div>
            {items.length < total && (
              <div className="text-center mt-10">
                <button onClick={loadMore} data-testid="load-more-btn" className="bg-black text-white font-bold uc text-sm px-8 py-3 hover:bg-r24-red transition-colors">Load More</button>
              </div>
            )}
          </>
        )}
      </section>
    </Layout>
  );
}
